export default {
    title: 'Nueva Autorización',
    type: 'Tipo de autorización',
    typeSubtitle: 'Seleccione un tipo de autorización para continuar:',
    footerTitle: 'Seleccione un tipo de autorización para poder continuar',
    backBtn: 'Cancelar',
    continueBtn: 'Continuar',
    medicalTypes : {
        subHeader: 'Atenciones ambulatorias',
        medicines: 'Medicamentos',
        diagnostic: 'Éxamenes por imagen',
        diagnostic_study: 'Estudio diagnóstico',
        laboratories: 'Laboratorios',
        outpatientCare: 'Consulta médica',
        procedure: 'Procedimiento',
        generic: 'Generico'
    },
    navBar: {
        medicines: '(Medicamentos)',
        diagnostic: '(Éxamenes por imagen)',
        diagnostic_study: '(Estudio diagnóstico)',
        laboratories: '(Laboratorios)',
        outpatientCare: '(Consulta médica)',
        procedure: '(Procedimientos)'
    }
}